<div class="company-detail" *ngIf="company">
  <div class="company-detail__hero" [style.backgroundColor]="company.headerColor || '#89CCDC'">
    <button class="company-detail__nav-btn company-detail__nav-btn--prev" [disabled]="!canGoPrevious" (click)="goPrevious()">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m15 18-6-6 6-6"/></svg>
    </button>
    <button class="company-detail__nav-btn company-detail__nav-btn--next" [disabled]="!canGoNext" (click)="goNext()">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m9 18 6-6-6-6"/></svg>
    </button>
  </div>

  <div class="company-detail__body">
    <button class="company-detail__back" (click)="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m15 18-6-6 6-6"/></svg>
      <span>{{ 'shared.back' | translate }}</span>
    </button>

    <div class="company-detail__card">
      <div class="company-detail__header">
        <h1 class="company-detail__title">{{ company.name }}</h1>
        <p class="company-detail__sector">{{ company.sector }}</p>
      </div>

      <div class="company-detail__info-grid">
        <div class="company-detail__info-item">
          <span class="company-detail__info-label">{{ 'companies.detail.location' | translate }}</span>
          <span class="company-detail__info-value">{{ company.location }}</span>
        </div>
        <div class="company-detail__info-item">
          <span class="company-detail__info-label">{{ 'companies.detail.employees' | translate }}</span>
          <span class="company-detail__info-value">{{ company.employees }}</span>
        </div>
        <div class="company-detail__info-item">
          <span class="company-detail__info-label">{{ 'companies.detail.founded' | translate }}</span>
          <span class="company-detail__info-value">{{ company.founded }}</span>
        </div>
        <div class="company-detail__info-item">
          <span class="company-detail__info-label">{{ 'companies.detail.offices' | translate }}</span>
          <span class="company-detail__info-value">{{ company.offices }}</span>
        </div>
      </div>

      <div class="company-detail__section" *ngIf="company.about">
        <h2>{{ 'companies.detail.about' | translate }}</h2>
        <p>{{ company.about }}</p>
      </div>

      <div class="company-detail__section" *ngIf="company.mission">
        <h2>{{ 'companies.detail.mission' | translate }}</h2>
        <p>{{ company.mission }}</p>
      </div>

      <div class="company-detail__section" *ngIf="company.values?.length">
        <h2>{{ 'companies.detail.values' | translate }}</h2>
        <div class="company-detail__values">
          <span *ngFor="let value of company.values" class="company-detail__value-tag">{{ value }}</span>
        </div>
      </div>

      <div class="company-detail__section" *ngIf="company.vacancies?.length">
        <h2>{{ 'companies.detail.open_vacancies' | translate }}</h2>
        <div class="company-detail__vacancies-list">
          <div *ngFor="let vac of company.vacancies" class="company-detail__vacancy-item">
            <div>
              <strong>{{ vac.title }}</strong>
              <span class="company-detail__vacancy-meta">{{ vac.location }} · {{ vac.type }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="company-detail__footer">
    <div class="company-detail__footer-inner">
      <a [routerLink]="['/profile-check/companies', company.id, 'vacancies']" class="company-detail__footer-btn company-detail__footer-btn--primary">
        {{ 'companies.detail.view_vacancies' | translate }}
      </a>
      <button
        class="company-detail__footer-btn company-detail__footer-btn--follow"
        [class.company-detail__footer-btn--following]="isFollowing"
        (click)="toggleFollow()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" [attr.fill]="isFollowing ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2">
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
        </svg>
      </button>
    </div>
  </div>
</div>
